var _path, _path2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgPending = function SvgPending(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8C0 3.58172 3.58172 0 8 0C12.4163 0.00477656 15.9952 3.5837 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8ZM1.3334 8.00006C1.3334 11.682 4.31817 14.6667 8.00006 14.6667C11.6803 14.6627 14.6627 11.6803 14.6667 8.00006C14.6667 4.31817 11.682 1.3334 8.00006 1.3334C4.31817 1.3334 1.3334 4.31817 1.3334 8.00006Z",
    fill: "#FFAA00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32941 2.3999C8.14748 2.3999 8 2.5566 8 2.7499V13.2499C8 13.4432 8.14748 13.5999 8.32941 13.5999C11.2403 13.5999 13.6 11.0927 13.6 7.9999C13.6 4.90711 11.2403 2.3999 8.32941 2.3999Z",
    fill: "#FFAA00"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPending, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pending.941184fb.svg";
export { ForwardRef as ReactComponent };